import Vue from 'vue';

// @ts-ignore
import VCalendar from 'v-calendar';

Vue.use(VCalendar, {
  componentPrefix: 'cfs',
  datePicker: {
    popover: {
      visibility: 'focus',
    },
  },
});
